
/* injects from baggage-loader */

'use strict';

export default class LoginController {

	constructor($log, $state, $location, $stateParams, User) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$location = $location;
		this.UserService = User;

		// Hold user login credentials
		this.user = {
			email: '',
			password: ''
		};

		// Hold login error details
		this.error = {};

		// Get the referral page from state params
		this.referral = $stateParams.ref;

	}

	$onInit() {

		// this.$log.log(this.$stateParams);
		// Check for current user
		// let user = this.UserService.getCurrent();

	}

	login() {

		// Reset error
		this.error = {};

		// Attempt to authenticate the user
		this.UserService.authenticate(this.user)
		.then(user => {
			if (typeof this.referral !== 'undefined') {
				this.$location.path(this.referral).search({});
			} else {
				this.$state.go('account.home');
			}
		})
		.catch(err => {
			this.error = err;
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js